"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompareOperations = exports.useStringOperations = void 0;
const common_types_1 = require("../../common-types");
const list_source_hook_1 = require("../../utils/list-source-hook");
function useStringOperations() {
    return (0, list_source_hook_1.useStaticListSource)([
        {
            id: common_types_1.ApiFilterOperation.CONTAINS,
            name: 'Obsahuje',
        },
        {
            id: common_types_1.ApiFilterOperation.EQ,
            name: '=',
        },
    ]);
}
exports.useStringOperations = useStringOperations;
function useCompareOperations() {
    return (0, list_source_hook_1.useStaticListSource)([
        {
            id: common_types_1.ApiFilterOperation.EQ,
            name: '=',
        },
        {
            id: common_types_1.ApiFilterOperation.GT,
            name: '>',
        },
        {
            id: common_types_1.ApiFilterOperation.LT,
            name: '<',
        },
        {
            id: common_types_1.ApiFilterOperation.LTE,
            name: '<=',
        },
        {
            id: common_types_1.ApiFilterOperation.GTE,
            name: '>=',
        },
    ]);
}
exports.useCompareOperations = useCompareOperations;
//# sourceMappingURL=field-filter-api.js.map